import { AttachmentGroup } from "@rms-types/modules/attachment-group/entities/attachment-group";

const index = "attachment-group";
const getOneAttachmentGroup = (attachmentGroupId: AttachmentGroup["id"]) => `${index}/${attachmentGroupId}`;
const getAttachments = (attachmentGroupId: AttachmentGroup["id"]) =>
  `${getOneAttachmentGroup(attachmentGroupId)}/attachment`;

export const attachmentGroupEndpoint = Object.freeze({
  attachmentGroup: index,
  getOneAttachmentGroup,
  getAttachments,
});
